<template>
  <Teleport to="body">
    <Transition name="loading-fade">
      <div v-if="isVisible" class="qc-loading">
        <img src="./images/small.gif" class="qc-loading-icon" />
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, onUnmounted } from 'vue';

const isVisible = ref(false);
// 声明组件可以触发的事件
const emit = defineEmits<{
  destroy: []
}>();

/**
 * 显示 Loading
 */
const show = () => {
  isVisible.value = true;
};

/**
 * 隐藏 Loading
 */
const hide = () => {
  isVisible.value = false;
};
// 组件卸载时触发destroy事件
onUnmounted(() => {
  emit('destroy');
});

defineExpose({
  show,
  hide
});
</script>

<style lang="less" scoped>
.QCLoadingStyle() {
  .qc-loading {
    transition: all 0.3s ease-in-out;
    position: fixed;
    z-index: 999999;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.05);
  }

  .qc-loading-icon {
    width: 200px;
    height: 194px;
    transform: scale(calc(var(--qc-scale-ratio) * 0.5));
    position: relative;
    top: -6%;
  }
}

.QCLoadingStyle();

@media (min-width: 750px) {
  .QCLoadingStyle();
}

</style>